import { RHTextSanitizer } from "../Custom components/RH/Utils_slop/RHTextSanitizer"


export class RHProcurementDeadlineAutoExtensionPresentation {

    static offererDescriptionHTMLWithProcurementTitleAndNewDeadlineText(
        procurementTitle?: string,
        newDeadlineText?: string
    ): string {
        let procurementName = ""
        if (procurementTitle?.trim()) {
            procurementName = ` „${RHTextSanitizer.escapedHTML(procurementTitle.trim())}“`
        }
        let description = `Hanke${procurementName} pakkumuste esitamise tähtaeg pikenes automaatselt, ` +
            "sest tähtajaks ei laekunud nõutav arv pakkumusi."
        if (newDeadlineText) {
            description += ` Uus tähtaeg: ${RHTextSanitizer.escapedHTML(newDeadlineText)}.`
        }
        return description +
            "<br>Esitatud pakkumused on suletud, neid ei näe keegi peale pakkuja enda, ka mitte hankija. " +
            "Kuni uue tähtajani saad oma pakkumust muuta, tagasi võtta või uuesti esitada."
    }

}
